import React from 'react';

import { Outlet, useLocation, useParams } from 'react-router-dom';

import { Alert, Box, Container } from '@mui/material';

import { useGetAccount } from '~/hooks/apis/offers/useGetAccount';

import ApiError from '~/types/ApiError';

import OfferBuilderSidebar from '../OfferBuilderSidebar';
import { useSidebarCollapsed } from '../shared/useSidebarCollapsed';

import { useAccountOfferId } from './useAccountOfferId';

export default function AccountShell() {
  const { id_account: accountId } = useParams<{ id_account: string }>();
  const { pathname } = useLocation();
  const offerId = useAccountOfferId();
  const { data: account, error } = useGetAccount(accountId);
  const { isSidebarCollapsed, toggleSidebarCollapsed } = useSidebarCollapsed();
  const isNotFound = error instanceof ApiError && error.status === 404;

  return (
    <Container sx={{ maxWidth: 1800 }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', lg: isSidebarCollapsed ? '56px minmax(0, 1fr)' : '280px minmax(0, 1fr)' },
        }}
      >
        <OfferBuilderSidebar
          accountId={accountId}
          activeItem={pathname.endsWith('/feed') ? 'Feed' : 'Related'}
          collapsed={isSidebarCollapsed}
          hotelCode={accountId}
          hotelName={account?.name || accountId}
          offerId={offerId}
          onToggleCollapsed={toggleSidebarCollapsed}
        />

        <Box sx={{ minWidth: 0, px: { xs: 2, md: 4 }, py: 3 }}>
          {isNotFound ? (
            <Alert severity="warning">No Salesforce Account found with id {accountId}.</Alert>
          ) : (
            <>
              {error && <Alert severity="error">Could not load the Account: {error.message}</Alert>}
              <Outlet />
            </>
          )}
        </Box>
      </Box>
    </Container>
  );
}
